/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import {FormControlLabel} from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';
import Divider from 'material-ui/Divider';
import Typography from 'material-ui/Typography';

class BillingInfo extends React.Component {

  constructor(props) {
     super(props);

     if(props.fields){
       this.state = props.fields;
     } else {
       this.state = {signOrder:true};
     }

     this.validateNow = this.validateNow.bind(this);
  }

  validateNow = ()  => {
    if(this.state.signOrder){
      this.props.onSubmit(this.state);
    } else {
    }
  }

  //to setstate from all the fields
  handleChange =name=> event=> {
    this.setState({ [name]: event.target.checked });
  }

  render() {

    return (
      <div >
        <Divider light />
        <Typography type="title" className="headline">Billing Information</Typography>
        <br/>
        <FormControlLabel
          control={
            <Checkbox checked={this.state.signOrder} value="signOrder"
              onChange={this.handleChange('signOrder')}/>
          }
          label="I will sign and send a sale order."
        />
        <br/>
        <b>This billing option is only available to accounts that plan to send 500,000 email transmissions per month or more.</b><br/>
        Please complete, sign and fax sales order agreement to (301) 990-9856.
      </div>
    );
  }
}

export default BillingInfo;



// WEBPACK FOOTER //
// ./src/components/billinginfo.js